import { useMemo } from "preact/hooks";
import { DataManagementService } from "../services/dataManagement";
import { useAuthStore } from "../stores/authStore";

/** Memoized DM client bound to the current PKCE session (auto-refreshes token). */
export function useDataManagementService(): DataManagementService {
  const ensureAccessToken = useAuthStore(s => s.ensureAccessToken);
  return useMemo(
    () => new DataManagementService(ensureAccessToken),
    [ensureAccessToken]
  );
}
